var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"unex-button-container",on:{"click":_vm.handleClick}},[_c('span',{staticClass:"unex-button",class:[
      ("unex-button-" + _vm.size),
      ("unex-button-" + _vm.type),
      _vm.disabled ? "unex-button-disabled" : ''
    ]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }